export default __webpack_public_path__ + "static/media/objectives_icon_1.9ea21a83.png";